import getCombatantIndexById from "./getCombatantIndexById";
import store from "../store/index";
//----------------
// update CA slot
//----------------
export default function updateCASlot(parm) {
  // console.log("=======================");
  // console.log("updateCASlot");
  //--------------
  // access store
  //--------------
  const this_store = store.state.combat;
  let combatants = this_store.arena.arena_combatants;
  //--------------------
  // get combatant index
  //--------------------
  // console.log("combatant = " + parm.combatant);
  let idx = getCombatantIndexById(parm.combatant);
  // console.log("idx = " + idx);
  //------------
  // set fields
  //------------
  let ca = "ca_slug" + parm.ca.number;
  let type = "ca_type" + parm.ca.number;
  //------------------
  // update slug/type
  //------------------
  combatants[idx][ca] = parm.ca.slug;
  combatants[idx][type] = parm.type;
  //------------------------------------------------------------------
  // update actual/action/marker count (actual built into serializer)
  //------------------------------------------------------------------
  combatants[idx].action_count = parm.ca.action_count;
  combatants[idx].actual_action_count = parm.ca.actual_action_count;
  // console.log(">>>----------------------------");
  // console.log("combatants[idx][ca] slug = " + combatants[idx][ca]);
  // console.log("combatants[idx][type] = " + combatants[idx][type]);
  // console.log("combatants[idx].action_count = " + combatants[idx].action_count);
  // console.log("combatants[idx].actual_action_count = " + combatants[idx].actual_action_count);
  // console.log("<<<----------------------------");
}
